import { Component, Input, OnInit } from '@angular/core';
import * as dayjs from 'dayjs';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-single-forms-answers',
  templateUrl: './single-forms-answers.component.html',
  styleUrls: ['./single-forms-answers.component.scss'],
})
export class SingleFormsAnswersComponent implements OnInit {
  @Input() workoutData: any;
  @Input() userId!: number;
  @Input() formType?: string;

  forms: any;

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    if (this.formType) {
      this.getUserCheckForms();
    } else if (this.workoutData) {
      this.forms = [{ responses: this.workoutData.pendingForm }];
    }
  }

  getUserCheckForms() {
    this.userService
      .getUserForm(this.userId, this.formType!)
      .subscribe((forms: any) => {
        if (!forms.forms) return;

        this.forms = forms.forms.filter((form: any) => {
          form.responses.forEach((response: any) => {
            if (parseInt(response.answer)) {
              response.answer = parseInt(response.answer);
            }
          });

          const completedAt = dayjs(form.completed_at);
          if (completedAt.year() === 0 || !completedAt.year()) {
            delete form['completed_at'];
          }

          return form;
        });
      });
  }
}
